<app-close [outlet]="'modal'" testId="dialog-upload-assessment-close" />

@if (loaded() === null) {
    <div class="loading">
        <app-loader />
    </div>
} @else {
    <div class="container">
        @if (pending()) {
            @let _assessment = assessment();

            <div class="message">
                <h2>{{ _assessment?.name }}</h2>
                <p>{{ _assessment?.description }}</p>

                @if (_assessment?.submission?.status === 'resubmission_required') {
                    <p class="resubmission">{{ 'assessment.upload.resubmission' | translate }}</p>
                }
            </div>

            @if (uploadFailed()) {
                <div class="upload-failed" data-test="dialog-upload-assessment-failed">
                    <p class="failed">{{ uploadFailedKey() | translate }}</p>

                    <button
                        type="button"
                        appBtn
                        [text]="'assessment.upload.try-again' | translate"
                        data-test="dialog-upload-assessment-retry"
                        (click)="retry()"
                    ></button>
                </div>
            } @else if (submitFailed()) {
                <div class="upload-failed" data-test="dialog-upload-assessment-submit-failed">
                    <p class="failed">{{ 'assessment.upload.submit-failed' | translate }}</p>

                    <button
                        type="button"
                        appBtn
                        [text]="'assessment.upload.try-again' | translate"
                        data-test="dialog-upload-assessment-retry-submit"
                        (click)="retrySubmit()"
                    ></button>
                </div>
            } @else {
                <app-form-file
                    identifier="assessment-file"
                    testId="dialog-upload-assessment-file"
                    [label]="'assessment.upload.label' | translate"
                    [hint]="uploadHint"
                    [accept]="acceptTypes"
                    [extensions]="acceptExtensions"
                    [maxSize]="maxSize"
                    [maxFiles]="1"
                    [disabled]="uploading()"
                    (selected)="onFileSelected($event)"
                />

                @if (scanning()) {
                    <p class="scanning">{{ 'assessment.upload.scanning' | translate }}</p>
                }
            }
        } @else if (submitted()) {
            @let _submission = assessment()?.submission;

            <div class="message">
                <h2>{{ 'assessment.upload.submitted-title' | translate }}</h2>
                <p>{{ 'assessment.upload.submitted-description' | translate }}</p>
            </div>

            @if (_submission) {
                <a
                    class="submission"
                    target="_blank"
                    [href]="_submission.url"
                    [attr.aria-label]="('link.download' | translate) + ' ' + _submission.fileName"
                    data-test="dialog-upload-assessment-download"
                    download
                >
                    <app-icon icon="document" [size]="20" />
                    <span class="name">{{ _submission.fileName }}</span>
                    <app-icon icon="download-2" [size]="16" class="fill-primary" />
                </a>
            }

            <div class="actions">
                <a
                    [routerLink]="['/', { outlets: { modal: ['course-completed'] } }]"
                    [queryParams]="{ courseId: courseId(), pathId: pathId(), nextCourseId: nextCourseId() }"
                    appBtn
                    [fluid]="true"
                    [text]="'course.completed.ok' | translate"
                    data-test="dialog-upload-assessment-ok"
                ></a>

                <a
                    [routerLink]="['/', { outlets: { primary: 'dashboard', modal: null } }]"
                    appBtn
                    [fluid]="true"
                    [text]="'course.completed.dashboard' | translate"
                    data-test="dialog-upload-assessment-dashboard"
                ></a>
            </div>
        } @else {
            <div class="message">
                <h2>{{ 'assessment.upload.unavailable-title' | translate }}</h2>
                <p>{{ 'assessment.upload.unavailable-description' | translate }}</p>
            </div>

            <div class="actions">
                <a
                    [routerLink]="['/', { outlets: { primary: 'dashboard', modal: null } }]"
                    appBtn
                    [fluid]="true"
                    [text]="'course.completed.dashboard' | translate"
                    data-test="dialog-upload-assessment-unavailable-dashboard"
                ></a>
            </div>
        }
    </div>
}
